"use client";
import { useEffect, useRef } from "react";
import styles from "./CursorLoadingSpinner.module.css";

export function CursorLoadingSpinner() {
  const spinnerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleMouseMove = (event: MouseEvent) => {
      const spinner = spinnerRef.current;
      if (spinner) {
        spinner.style.left = `${event.clientX}px`;
        spinner.style.top = `${event.clientY}px`;
      }
    };

    handleMouseMove({
      clientX: window.innerWidth / 2,
      clientY: window.innerHeight / 2,
    } as MouseEvent);

    document.addEventListener("mousemove", handleMouseMove);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <div ref={spinnerRef} id="loading-spinner" className={styles.spinner} />
  );
}
